module.exports = __webpack_public_path__ + "font/4df32891a5f2f98a363314f595482e08.woff";